import React from 'react';
import PropTypes from 'prop-types';
import { FieldArray } from 'formik';
import { Row, Col } from 'reactstrap';
import forms from 'constants/forms';
import Input from 'components/atoms/input';
import PlusIcon from 'components/atoms/icons/plus';
import { format } from 'date-fns';
import RemoveIcon from 'components/atoms/icons/remove';

const priorAuth = ({ values, errors }) => {
  const priorAuths = [...forms.adminPanelsUser.userEdit.priorAuth];
  return (
    <FieldArray name="priorAuths">
      {({ remove, push }) => (
        <div className="admin-patient-form-block">
          <div className="admin-patient-form-block-add">
            <span>Prior authorization</span>
            <span
              className="admin-patient-form__add-button"
              onClick={() => {
                push({
                  authorizationNumber: '',
                  startDate: format(new Date(), 'MM/dd/yyyy'),
                });
              }}
            >
              <PlusIcon />
            </span>
          </div>
          {values.priorAuths.map((value, index) => (
            <Row key={`priorAuths.${index}.${values.priorAuths.length}`}>
              {priorAuths.map((field) => (
                <Col lg="6" md="6" sm="6" xs="12" key={`${index}.${field.id}`}>
                  <Input
                    id={`priorAuths.${index}.${field.id}`}
                    label={field.label}
                    type={field.type}
                    min={0}
                  />
                  {errors?.priorAuths?.[index]?.[field.id] ? (
                    <div className="input-error">
                      {errors?.priorAuths?.[index]?.[field.id]}
                    </div>
                  ) : null}
                </Col>
              ))}
              <span
                className="admin-patient-form__remove-button"
                onClick={() => {
                  remove(index);
                }}
              >
                <RemoveIcon />
              </span>
            </Row>
          ))}
        </div>
      )}
    </FieldArray>
  );
};

priorAuth.propTypes = {
  values: PropTypes.shape(),
  errors: PropTypes.shape(),
};

export default priorAuth;
